<template>
    <div>
        <common-table :url="url"
                      :table-columns="tableColumns"
                      :form-fields="formFields"
                      :operate="[]"
                      :permission="permission"
                      :searchs="[]"
                      ref="table"/>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "TransactionRecord",
        components: {CommonTable},
        data() {
            return {
                permission:{
                    add: 'transactionRecord:add',
                    /*update: 'transactionRecord:update',
                    delete: 'transactionRecord:delete',
                    deleteBatch: 'transactionRecord:deleteBatch'*/
                },
                url: {
                    get: '/transactionRecord/listByCondition',
                    //add: '/transactionRecord/add',
                    //update: '/transactionRecord/update',
                    //delete: '/transactionRecord/delete/',
                    //delete_batch: '/transactionRecord/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'phone',
                    label: '用户',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'type',
                    label: '类型',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'network',
                    label: '币种',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'blockNo',
                    label: '区块编号',
                    show: false,
                    detail: true,
                    width: '',
                }, {
                    field: 'height',
                    label: '权重',
                    show: false,
                    detail: true,
                    width: '',
                }, {
                    field: 'index',
                    label: 'index',
                    show: false,
                    detail: true,
                    width: '',
                }, {
                    field: 'txId',
                    label: '交易ID',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'fee',
                    label: '手续费',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'tType',
                    label: '交易类型',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'confirmations',
                    label: '确认号',
                    show: false,
                    detail: true,
                    width: '',
                }, {
                    field: 'from',
                    label: '出款地址',
                    show: false,
                    detail: true,
                    width: '',
                }, {
                    field: 'to',
                    label: '入口地址',
                    show: false,
                    detail: true,
                    width: '',
                }, {
                    field: 'value',
                    label: '交易数量',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'gasFee',
                    label: 'gas手续费',
                    show: false,
                    detail: true,
                    width: '',
                }, {
                    field: 'gasUsed',
                    label: '免费gas',
                    show: false,
                    detail: true,
                    width: '',
                }, {
                    field: 'gasLimit',
                    label: 'gas总量',
                    show: false,
                    detail: true,
                    width: '',
                }, {
                    field: 'netFee',
                    label: '带宽手续费',
                    show: false,
                    detail: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                },{
                    field: 'transferType',
                    label: '转账类型',
                    show: {
                        type: 'tag',
                        tags:[
                            {
                                key: 1,
                                value: '转入',
                                type: 'primary'
                            },{
                                key: 0,
                                value: '转出',
                                type: 'warning'
                            }
                        ]
                    },
                    width: '',
                }, {
                    field: 'time',
                    label: '交易时间',
                    show: true,
                    detail: true,
                    width: '100',
                }, {
                    field: 'expiration',
                    label: '到期时间',
                    show: true,
                    detail: true,
                    width: '100',
                }],
                formFields: {model: []},
            }
        }
    }
</script>

<style scoped>

</style>
